import { render, staticRenderFns } from "./AdviserVideoGrid.vue?vue&type=template&id=86777ac4&scoped=true"
import script from "./AdviserVideoGrid.vue?vue&type=script&lang=js"
export * from "./AdviserVideoGrid.vue?vue&type=script&lang=js"
import style0 from "./AdviserVideoGrid.vue?vue&type=style&index=0&id=86777ac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86777ac4",
  null
  
)

export default component.exports